import React from "react";
import { useNavigate } from "react-router-dom";
import { Play, X } from "lucide-react";
import { imgUrl } from "../lib/api";

export const ContinueCard = ({ item, onRemove, index = 0 }) => {
  const navigate = useNavigate();
  const pct = Math.round((item.percent || 0) * 100);
  return (
    <div
      style={{ animationDelay: `${index * 60}ms` }}
      className="group relative shrink-0 w-72 sm:w-80 snap-start animate-fade-up"
      data-testid={`continue-card-${item.episodeId}`}
    >
      <button onClick={() => navigate(`/watch/${item.episodeId}`)} className="block w-full text-left">
        <div className="relative aspect-video overflow-hidden rounded-lg bg-[#0A0A0A] border border-white/5 group-hover:border-blood/60 transition-all duration-300 group-hover:shadow-[0_0_24px_rgba(220,20,60,0.25)]">
          {item.thumbnail ? (
            <img src={imgUrl(item.thumbnail)} alt={item.episodeTitle} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white/20">{item.seriesTitle}</div>
          )}
          <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
            <Play size={34} className="fill-white text-white drop-shadow-[0_0_10px_rgba(220,20,60,0.8)]" />
          </div>
          <div className="absolute bottom-0 inset-x-0 h-1.5 bg-white/15">
            <div className="h-full bg-blood glow-box" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </button>
      <button
        onClick={() => onRemove(item.episodeId)}
        data-testid={`continue-remove-${item.episodeId}`}
        className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/70 backdrop-blur flex items-center justify-center text-white/70 hover:text-white hover:bg-blood transition-colors opacity-0 group-hover:opacity-100"
        aria-label="Remove"
      >
        <X size={15} />
      </button>
      <p className="mt-2 text-[11px] font-bold tracking-widest uppercase text-blood">{item.seriesTitle} · S{item.season}E{item.episode}</p>
      <p className="text-sm font-semibold text-white/90 truncate group-hover:text-blood transition-colors">{item.episodeTitle}</p>
    </div>
  );
};
